import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function RequireAuth({ children }: { children: JSX.Element }) {
  const { userAuthenticated } = useAuth();
  const location = useLocation();

  if (!userAuthenticated) {
    return (
      <Navigate to="/" replace state={{ from: location }} />
    );
  }

  return children;
}
